// Firebase web SDK init — used for Google Analytics (Firebase console dashboard).
// The web API key is a public client identifier (safe to embed), not a secret.
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

let app = null;
let analytics = null;

// Only initialize when the app is actually configured (avoids errors in dev/CI
// with empty env). Analytics needs a measurementId (Google Analytics linked).
if (firebaseConfig.apiKey && firebaseConfig.appId) {
  app = initializeApp(firebaseConfig);
  if (firebaseConfig.measurementId) {
    isSupported()
      .then((ok) => {
        if (ok) analytics = getAnalytics(app);
      })
      .catch(() => {
        /* analytics unsupported in this environment — ignore */
      });
  }
}

export { app, analytics };
